import {
  ADD_SLIDER,
  EDIT_SLIDER,
  GET_SLIDERS,
  GET_SLIDER_BY_ID,
  REMOVE_SLIDER,
} from "../actions/slider-actions";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const SliderReducer = (state = initialState, action: any): ApiRequestState => {
  switch (action.type) {
    case (ADD_SLIDER.REQUEST,
    GET_SLIDERS.REQUEST,
    GET_SLIDER_BY_ID.REQUEST,
    EDIT_SLIDER.REQUEST,
    REMOVE_SLIDER.REQUEST):
      return {
        ...state,
        loading: true,
        error: null,
      };
    case (ADD_SLIDER.SUCCESS,
    GET_SLIDERS.SUCCESS,
    GET_SLIDER_BY_ID.SUCCESS,
    EDIT_SLIDER.SUCCESS,
    REMOVE_SLIDER.SUCCESS):
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case (ADD_SLIDER.FAILURE,
    GET_SLIDERS.FAILURE,
    GET_SLIDER_BY_ID.FAILURE,
    EDIT_SLIDER.FAILURE,
    REMOVE_SLIDER.FAILURE):
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { SliderReducer };
